import React from "react";
import { Urls } from "../constants/UrlConstants";
import layoutStyle from "../assets/css/modules/shared/layout.css";

const accessRestricted = "Access restricted";
const cannotAccessPlanOnline = "You cannot access your plan online";
const cannotAccessPolicyOnline = "You cannot access your policy online";

const accessRestrictedForPolicyOrUser = {
  HeaderText: {
    Any: cannotAccessPlanOnline,
    HOL: cannotAccessPolicyOnline
  },
  PageTitle: accessRestricted,
  Message: {
    Any: (
      <React.Fragment>
        <p>
          There seems to be a problem with online access to your account. Please
          call us on <b>0800 302 9133</b> and we'll be happy to help. Lines are
          open 8am to 8pm, Monday to Friday, and 9am to 5pm Saturday.
        </p>
        <p>
          We may record and/or monitor calls for quality assurance, training and
          record keeping purposes.
        </p>
        <br />
      </React.Fragment>
    ),
    HOL: (
      <React.Fragment>
        <p>
          There seems to be a problem with online access to your account. Please
          call us on <b>01202 544032</b> and we'll be happy to help. Lines are
          open 8am to 6pm, Monday to Friday.
        </p>
        <p>
          We may record and/or monitor calls for quality assurance, training and
          record keeping purposes.
        </p>
        <br />
      </React.Fragment>
    )
  },

  Link: (
    <React.Fragment>
      Back to login <span className="ml-2">➔</span>
    </React.Fragment>
  )
};

const ErrorPages = {
  GenericError: {
    // HeaderText: "Error",
     PageTitle: "Error",
    HeaderText: {
      Any: 
      (
        <React.Fragment>Whoops, something went wrong.
          </React.Fragment>
          ),
      HOL:"Error"
    },
    Message: {
      Any:(
        <React.Fragment>
        <p style={{fontSize: "15px"}}>To return to the login page, please use the link below.</p>
        </React.Fragment>
      ),
      HOL:
      (
        <React.Fragment>
        <p>To return to the Login page, please use the link below.</p>
      </React.Fragment>
      )
    }
    ,
    Link: {
      Any:(
        <React.Fragment>
        <span className="ml-2">➔</span>
        </React.Fragment>
      ),
       HOL:""
    }
  },
  Locked: {
    HeaderText: "Your account is locked",
    PageTitle: "Account Locked",
    Message: {
      Any: (
        <React.Fragment>
          <p>
            As you've entered incorrect details too many times your account has
            been locked.
          </p>
          <p>
            Please contact our team of Personal Advisors for assistance. We may
            record and/or monitor calls for quality assurance, training and
            record keeping purposes.
          </p>
          <br />
          <h5 className="axa-headline">UK members</h5>
          <p className="axa-body-text-2">
            <b>Call 0800 302 9133</b>
          </p>
          <p>
            Lines are open 8am to 8pm, Monday to Friday, and 9am to 5pm
            Saturday.
          </p>
          <br />
          <h5 className="axa-headline">International customers</h5>
          <p className="axa-body-text-2">
            <b>Call +44 (0) 1892 596432</b>
          </p>
          <p>Lines are open 24 hours a day, 7 days a week.</p>
          <br />
        </React.Fragment>
      ),
      HOL: (
        <React.Fragment>
          <p>
            As you've entered incorrect details too many times your account has
            been locked.
          </p>
          <p>
            Please contact our team of Personal Advisors for assistance. We may
            record and/or monitor calls for quality assurance, training and
            record keeping purposes.
          </p>
          <br />
          <p className="axa-body-text-2">
            <b>Call 01202 544032</b>
          </p>
          <p>Lines are open 8am to 6pm, Monday to Friday.</p>
        </React.Fragment>
      )
    },
    Link: (
      <React.Fragment>
        Back to login <span className="ml-2">➔</span>
      </React.Fragment>
    )
  },
  LockedPolicy: {
    HeaderText: {
      Any: "Your plan is locked",
      HOL: "Your policy is locked"
    },
    PageTitle: "Access locked",
    Message: {
      Any: (
        <React.Fragment>
          <p>
            Please call us on <b>0800 302 9133</b> and we'll be able to help.
            Lines are open 8am to 8pm, Monday to Friday, and 9am to 5pm
            Saturday.
          </p>
          <p>
            We may record and/or monitor calls for quality assurance, training
            and record keeping purposes.
          </p>
        </React.Fragment>
      ),
      HOL: (
        <React.Fragment>
          <p>
            Please call us on <b>01202 544032</b> and we'll be able to help.
            Lines are open 8am to 6pm, Monday to Friday.
          </p>
          <p>
            We may record and/or monitor calls for quality assurance, training
            and record keeping purposes.
          </p>
        </React.Fragment>
      )
    },
    Link: (
      <React.Fragment>
        Back to login <span className="ml-2">➔</span>
      </React.Fragment>
    )
  },
  OnlineAccessUnavailable: {
    HeaderText: {
      // Any: cannotAccessPlanOnline,
      Any: "If you've got a current AXA Health plan...",
      HOL: cannotAccessPolicyOnline
    },
    HeaderTextsecond: {
      // Any: cannotAccessPlanOnline,
      Any: "If you’ve left AXA Health...",
    },
    PageTitle: "Online Access Unavailable",
    Message: {
      Any: (
        <React.Fragment>
          {/* <p>Unfortunately, online access isn't available for your plan.</p> */}
          <p style={{fontSize: "18px"}}>You no longer have access to your old plan, which was linked to this email address. However, you can link your new plan to access your online account.</p>
          {/* <p style={{fontSize: "15px"}}>
            If you think you should have access
            online, please call us on <strong>0800 302 9133.</strong> Lines are
            open 8am to 8pm, Monday to Friday, and 9am to 5pm Saturday.
          </p>           */}
          {/* <p>
            We may record and/or monitor calls for quality assurance, training
            and record keeping purposes.
          </p> */}
        </React.Fragment>
      ),
      HOL: (
        <React.Fragment>
          <p>Unfortunately, online access isn't available for your policy.</p>
          <p>
            If you have a personal policy and you think you should have access
            online, please call us on <strong>01202 544032.</strong> Lines are
            open 8am to 6pm, Monday to Friday.
          </p>
          <p>
            If you're on a company scheme, please contact your group secretary.
          </p>
          <p>
            We may record and/or monitor calls for quality assurance, training
            and record keeping purposes.
          </p>
        </React.Fragment>
      )
    },
    Messagesecond:{
      Any:(
        <React.Fragment>
          <p style={{fontSize: "18px",paddingBottom:"30px"}}>If you've left AXA Health, but need some information, please get in touch.</p>
          {/* <p>If you've left AXA Health, but need some information, please get in touch.</p> */}
        </React.Fragment>
      )
    },
    Messagethird:{
      Any:(
        <React.Fragment>
          <p style={{fontSize: "14px"}}>
          
            If you think you should have access online, please call us on <span style={{color:"#00008F",textDecorationLine:"underline"}}>0800 302 9133.</span>
            Lines are open 8am to 8pm, Monday to Friday, and 9am to 5pm Saturday.
          </p> 
        </React.Fragment>
      )
    },
    Link: (
      <React.Fragment>
        <span className="ml-2">➔</span>
      </React.Fragment>
    ),
    AddANewPlanLinkText: {
      // Any: "Add a new plan",
      Any: "LINK NEW PLAN",
      HOL: "Add a new policy"
    }
  },
  PageNotFound: {
    HeaderText: "Page not found",
    PageTitle: "Page not found",
    Message: <p>The page you are looking for doesn't exist.</p>,
    Link: (
      <React.Fragment>
        Back to login <span className="ml-2">➔</span>
      </React.Fragment>
    )
  },
  RestrictedGroup: {
    HeaderText: {
      Any: "Your plan is not available on Member Online",
      HOL: cannotAccessPolicyOnline
    },
    PageTitle: accessRestricted,
    Message: {
      Any: (
        <React.Fragment>
          <p>
            Unfortunately, this means that you will not be able to view your
            plan details online.
          </p>
          <h5 className="axa-headline">
            If your policy is provided by your company:
          </h5>
          <p>
            Your company have chosen not to use Member Online, please contact
            your company's group secretary for further information. You'll be
            able to access other details of the health and wellbeing benefits
            provided with your plan on your company's{" "}
            <a
              href={Urls.AXAWellbeingHub}
              target="_blank"
              rel="noopener noreferrer"
              className={layoutStyle.anchorDecorationUnderline}
            >
              Wellbeing Hub
            </a>
            .
          </p>
          <h5 className="axa-headline">
            If you have a Travel, Cashback or Dental policy:
          </h5>
          <p>
            These policies are not available to service in Member Online. For
            information on how to make a claim on these policies please{" "}
            <a
              href={Urls.AXACashBack}
              target="_blank"
              rel="noopener noreferrer"
              className={layoutStyle.anchorDecorationUnderline}
            >
              visit our website
            </a>
            .
          </p>
          <br />
        </React.Fragment>
      ),
      HOL: (
        <React.Fragment>
          <p>
            Online access is not currently available for your company policy.
            Please contact your group secretary if you need further information.
          </p>
          <br />
        </React.Fragment>
      )
    },
    Link: (
      <React.Fragment>
        Back to login <span className="ml-2">➔</span>
      </React.Fragment>
    )
  },
  RestrictedPolicy: accessRestrictedForPolicyOrUser,
  RestrictedUser: accessRestrictedForPolicyOrUser,
  Timeout: {
    // PageTitle: "Timeout",

    // HeaderText: "Timeout",
    HeaderText: {
      Any: (
        <React.Fragment>Whoops, you’ve run out of time.
          </React.Fragment>
          ),
      HOL:"Timeout"
    },
    PageTitle: "Timeout",

    Message: (
      <p>
        Your session has timed out. Please log in again using the link below.
      </p>
    ),
    MessageSSO: {
      Any: (
        <React.Fragment>
          <p>Your Member Online session has timed out.</p>
          <p  style={{fontSize: "15px"}}>
          Please select 'Continue' below to return to Member Online or 'Log out' to log out of your account.
          </p>
        </React.Fragment>
      ),
      HOL: (
        <React.Fragment>
          <p>Your Customer Online session has timed out.</p>
          <p>
            Please select 'Continue' below to return to Customer Online or 'Log
            out' to log out of your account.
          </p>
        </React.Fragment>
      )
    },
    Link: {
      Any:(
        <React.Fragment>

        <span className="ml-2">➔</span>
      </React.Fragment>
      ),
      HOL:""
      
    },
    ButtonLabel: "Continue"
  },
  SystemUnavailable: {
    HeaderText: "Site currently unavailable",
    PageTitle: "Site unavailable",
    Message: {
      Any: (
        <React.Fragment>
          <p>
            We are currently performing routine maintenance. We apologise for
            any inconvenience this may cause.
          </p>

          <h5 className="axa-headline">Do you want to talk to us?</h5>
          <p>
            Call our Personal Advisers:
            <br />
            <strong>0800 302 9133</strong>
          </p>
          <p>
            Or if you're calling from overseas:
            <br />
            <strong>+44 1892 512 345</strong>
          </p>
          <p>
            Calls made from UK landlines to 0800 numbers will not be charged. We
            may record and/or monitor calls. Lines are open 8am to 8pm Monday to
            Friday and 9am to 5pm Saturdays and Bank Holidays.
          </p>
          <br />
          <h5 className="axa-headline">
            24 hour medical help and information{" "}
          </h5>
          <p>
            Talk to a medical professional at any time, day or night:
            <br />
            <strong>0800 003 004</strong>
          </p>
          <p>
            We may record and/or monitor calls for quality assurance, training
            and as a record of our conversation.
          </p>
        </React.Fragment>
      ),
      HOL: (
        <React.Fragment>
          <p>
            We are currently performing routine maintenance. We apologise for
            any inconvenience this may cause.
          </p>

          <h5 className="axa-headline">Do you want to talk to us?</h5>
          <p>
            Call us on: <br /> <strong>01202 544444</strong>
          </p>
          <p>Lines are open 8am to 6pm Monday to Friday.</p>
          <br />
          <h5 className="axa-headline">
            24 hour medical help and information{" "}
          </h5>
          <p>
            Talk to a medical professional at any time, day or night:
            <br />
            <strong>0800 003 004</strong>
          </p>
          <p>
            We may record and/or monitor calls for quality assurance, training
            and as a record of our conversation.
          </p>
        </React.Fragment>
      )
    },
    Note: (
      <React.Fragment>
        <strong>Please note:</strong> If you were logged in when the site became
        unavailable, please
      </React.Fragment>
    )
  },
  TimeSettings: {
    PageTitle: "Check time settings"
  }
};
export default ErrorPages;
